

import {
  LOGIN_SUCCESS, LOGIN_ERROR,
  GET_ADDRESS_USER, LOG_OUT,
  JOB_REST, Lock_Page_Main, UPDATE_INFO_ACCOUNT, UPDATE_USER_DATA, SOCKET_CONNECT, REFRESH_TOKEN
} from './actionsType';


import config from '../../constants/config';


import store from '../store';




import * as requestMethods from '../../utils/RequestMethods'
export interface ActionRefreshTokenT {
  token: string
  refreshToken: string
  tokenExpires: number
}

export const restLogOut = async () => {
  await localStorage.removeItem('filter');
  await localStorage.removeItem('user');
  store.dispatch({ type: JOB_REST });
  store.dispatch({ type: LOG_OUT })
}

export const logOut = (force = false) => async dispatch => {
  if (force) {
    return restLogOut();
  }
  let res = await requestMethods.AxiosInstance.post(`${config.url.wpJson}/wp/v2/token/revoke`)
  restLogOut();
}

/**
 *
 * @param {userData} newData
 */
export const receiveUserData = async (newData) => {

  let user = localStorage.getItem('user')
  if (user != null) {
    let data = JSON.parse(user);

    if (data != null) {
      data = { ...data, ...newData }
      localStorage.setItem('user', JSON.stringify(data));
      store.dispatch({ type: UPDATE_INFO_ACCOUNT, data: newData })

    }
    // console.log("data", JSON.parse(localStorage.getItem("user")))
  }
}

/**
 * start auth
 */
export const InitAuth = () => async dispatch => {
  const _store = store.getState();
  const auth = _store.auth;
  let token = localStorage.getItem("token")
  console.log("startInitAuth",token);
  if (auth && auth.token && auth.userData) {

    let userData = auth.userData
    // console.log("startInitAuth->userdata",userData);

    dispatch(startServicSocket(userData.id, token))
    /**
     * asyncAccount
     */
    asyncUserData()
    return true;
  }

}





/**
 *
 * @param {response_success_login} data
 */
export const actionLoginSuccess = (data) => {

  return {
    type: LOGIN_SUCCESS, payload: {
      userData: data.data,
      token: data.token,
      refreshToken: data.refresh_token,
      tokenExpires: data.exp,
    }
  }
}


export const asyncLoginSuccess = (data) => async dispatch => {
  return await dispatch(loginSuccess(data)).then(() => {
    asyncUserData()
  })
}

export const loginSuccess = (data) => async dispatch => {
  console.log("loginSuccess", data.token)
  dispatch({
    type: LOGIN_SUCCESS,
    payload: {
      userData: data.data,
      token: data.token,
      refreshToken: data.refresh_token,
      tokenExpires: data.exp,
    }
  })
  dispatch(startServicSocket(data.data.id, data.token))
  // dispatch(startServicSocket(data.data.id, data.token))
}


export const actionRefreshToken = (data: ActionRefreshTokenT) => async dispatch => {
  dispatch({
    type: REFRESH_TOKEN,
    payload: {
      token: data.token,
      refreshToken: data.refreshToken,
      tokenExpires: data.tokenExpires,
    }
  })
}

/**
 *
 * @param {userData} data
 */
export const updateUserDataStore = (data) => async dispatch => {
  dispatch({ type: UPDATE_USER_DATA, payload: data, })
}

/**
 *
 */
export const asyncUserData = async () => {
  return await requestMethods.AxiosInstance.get(`${config.url.wpJson}/wp/v2/users/me`).then((res) => {
    if (res && res.data) {
      store.dispatch(updateUserDataStore(res.data));
      return res.data
    }
    return res
  })
}
// export const asyncUserData = async () => {
//   requestMethods.AxiosInstance.get(`${config.url.wpJson}/wp/v2/users/me`).then((res) => {
//     if (res && res.data) {
//       store.dispatch(updateUserDataStore(res.data));

//     }
//   }).catch((error) => {
//     console.log("error->updateUserData", error)
//   })
// }

/**
 * run service socket
 * @param userId  int
 * @param socket_token string
 */
export const startServicSocket = (userId, token) => async dispatch => {
  dispatch(socketConnect("", token, userId))
}

export const socketConnect = (host, token, userId) => async dispatch => {
  dispatch({ type: SOCKET_CONNECT, payload: { host: host, token: token, userId: userId } })
}
